export default __webpack_public_path__ + "static/media/Autobet_whitepaper.5d3c4dac.pdf";